/**
 * Chapter 9 — the morning in five presses: a checklist that presses itself
 * (wall-clock on the left, the ring on the control, a check once done).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Check } from 'lucide-react';

import { Press } from '../../motion/Accents';
import { Illustration } from '../../motion/Illustration';
import { Enter } from '../../motion/Node';
import { MORNING_STEPS } from '../../roadmap/morning';

const CYCLE = 12;
const STEP_TICKS = 2;

export const MorningIllustration: FC = () => (
  <Illustration cycleSeconds={CYCLE}>
    <ol className="flex flex-col gap-1.5 text-xs">
      {MORNING_STEPS.map((s, i) => (
        <li key={s.time} className="grid grid-cols-[44px_auto_1fr_20px] items-center gap-2">
          <span className="font-mono tabular-nums text-muted-foreground">{s.time}</span>
          <Press at={i * STEP_TICKS}>
            <span className="rounded-md border border-input bg-background px-2 py-1 font-medium">{s.where}</span>
          </Press>
          <span className="text-muted-foreground">{s.action}</span>
          <Enter at={i * STEP_TICKS + 1}>
            <Check className="h-3.5 w-3.5 text-success" />
          </Enter>
        </li>
      ))}
    </ol>
  </Illustration>
);
